module.exports = __webpack_public_path__ + "static/media/master_card.de51e8fa.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/master_card.png
// module id = 1905
// module chunks = 0